<template>
	<div class="showcard" :data-id="card.id">
		<div class="showcard__inner" v-if="card.type == 'Word'">
			<div class="showcard__inner__text">
				<h2 :style="{ fontSize: fontSize }">{{ card.title }}</h2>
			</div>
		</div>
		<!-- <div
      class="showcard__inner"
      :style="{ backgroundImage: `url(${card.src})` }"
      v-if="card.type == 'Image'"
    ></div> -->
		<div class="showcard__inner" v-if="card.type == 'Image'">
			<Imgx :src="card.src" />
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Imgx from './Imgx';
export default {
	name: 'ShowCard',
	components: {
		Imgx,
	},
	props: {
		card: Object,
		cols: Number,
		cellSize: Number,
	},
	data() {
		return {
			min: 0.8,
			max: 2,
		};
	},
	computed: {
		fontSize() {
			if (this.cellSize) {
				return `${this.cellSize / 100 * 0.7}rem`;
			} else {
				let unit = this.max / 10;
				let size = this.max - unit * this.cols + this.min;
				return `${size}rem`;
			}
		},
	},
};
</script>
